import { useRouteError } from "react-router";
import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import Heading from "./Heading";

const ErrorBoundary = () => {
  const error = useRouteError();

  useEffect(() => {
    if (error) Sentry.captureException(error);
  }, [error]);

  const errorMessage =
    error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : JSON.stringify(error);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-6 rounded-lg p-8 shadow-thick">
      <div className="flex flex-col items-center gap-2">
        <Heading text="An error occurred!" className="mb-2 text-2xl font-bold text-danger" />
        <span className="font-mono max-w-xl break-words rounded bg-danger/10 px-3 py-2 text-center text-base text-neutral-100">
          Error: {errorMessage}
        </span>
      </div>
    </div>
  );
};

export default ErrorBoundary;
